// http://pmapi.dholdingsltd.com
export const apiUrl = "https://apihrm.dtechcorpltd.com";
// export const isAdminLoggedIn = window.localStorage.getItem("admin");
// export const isEmployeeLoggedIn = window.localStorage.getItem("employeeToken");

export const isAdminLoggedIn = window.localStorage.getItem("adminLoggedIn");
export const isEmployeeLoggedIn = null;
